import { render, staticRenderFns } from "./noticeEdit.vue?vue&type=template&id=0c804ccf&"
import script from "./noticeEdit.vue?vue&type=script&lang=js&"
export * from "./noticeEdit.vue?vue&type=script&lang=js&"
import style0 from "./noticeEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports